import { CheckCircle2, Circle, Truck, Package, MapPin, Clock } from "lucide-react";

const STAGE_ICON = { pending: Package, packed: Package, in_transit: Truck, delivered: CheckCircle2, cancelled: Circle };

export function TrackingTimeline({ data }) {
  if (!data) return null;
  const stages = data.stages || [];
  const activities = data.timeline || [];
  const hasMeta = data.courier || data.awb || data.edd;

  return (
    <div className="space-y-6" data-testid="tracking-timeline">
      {/* Header meta */}
      {hasMeta && (
      <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm">
        {data.courier && (
          <div><span className="text-muted-foreground">Courier</span>
            <p className="text-gold-muted">{data.courier}</p></div>
        )}
        {data.awb && (
          <div><span className="text-muted-foreground">Tracking no.</span>
            <p className="font-mono text-gold" data-testid="tracking-awb">{data.awb}</p></div>
        )}
        {data.edd && (
          <div><span className="text-muted-foreground">Est. delivery</span>
            <p className="text-gold-muted">{data.edd}</p></div>
        )}
        <div>
          <span className="text-muted-foreground">Mode</span>
          <p className={data.live ? "text-green-400" : "text-amber-300"}>{data.live ? "Live" : "Status"}</p>
        </div>
      </div>
      )}

      {/* Stage stepper */}
      <div className="relative">
        {stages.map((s, i) => {
          const Icon = STAGE_ICON[s.key] || Circle;
          const last = i === stages.length - 1;
          return (
            <div key={s.key} className="flex gap-4 pb-6 last:pb-0 relative" data-testid={`tracking-stage-${s.key}`}>
              {!last && (
                <span className={`absolute left-[15px] top-8 bottom-0 w-0.5 ${s.done ? "bg-gold" : "bg-gold/20"}`} />
              )}
              <div className={`relative z-10 w-8 h-8 rounded-full grid place-items-center shrink-0 ${
                s.current ? "bg-gold text-obsidian" : s.done ? "bg-gold/25 text-gold" : "bg-obsidian-2 text-muted-foreground border border-gold/20"}`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="pt-1">
                <p className={`text-sm font-medium ${s.current ? "text-gold-light" : s.done ? "text-gold-muted" : "text-muted-foreground"}`}>{s.title}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{s.note}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Detailed live activities */}
      {activities.length > 0 && (
        <div className="border-t border-gold/15 pt-5">
          <p className="text-xs uppercase tracking-wider text-muted-foreground mb-3">Live courier updates</p>
          <div className="space-y-3">
            {activities.map((a, i) => (
              <div key={i} className="flex gap-3 text-sm" data-testid={`tracking-activity-${i}`}>
                <Clock className="w-3.5 h-3.5 text-gold/60 mt-1 shrink-0" />
                <div>
                  <p className="text-gold-muted">{a.activity || a.status}</p>
                  <p className="text-xs text-muted-foreground flex items-center gap-2 mt-0.5">
                    {a.date}{a.location ? <><MapPin className="w-3 h-3" /> {a.location}</> : null}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {data.track_url && (
        <a href={data.track_url} target="_blank" rel="noopener noreferrer" data-testid="tracking-external-link"
          className="inline-block text-xs text-gold underline">Open courier tracking page ↗</a>
      )}
    </div>
  );
}
